import { inheritLinks } from "../inherit-links/inherit-linnks.js";
import npl from "../next-post-logic/next-post-logic.js";
import lib from "../lib/lib.js";

export function projectFilter() {
    // Set Default API URL
    const $restAPI = window.location.protocol + '//' + window.location.hostname + '/wp-json/wp/v2/posts?&per_page=100';
    // Get Needed Elems
    let filterOptions = document.querySelectorAll('.filter-option');
    let postWrapper = document.querySelector('.portfolio-list-wrapper');
    let filterBtns = document.querySelectorAll('[data-slug]');
    const pageUrl = window.location.pathname;

    // Add/Remove active class on filter
    filterOptions.forEach((filterOption) => {
        //Hide Uncategorized Category Option
        //document.querySelector('[data-slug=uncategorized]').style.display = 'none';
        const uncat_element = document.querySelector('[data-slug=uncategorized]');
        if (uncat_element) {
            uncat_element.style.display = 'none';
        }

        filterOption.addEventListener('click', (e) => {
            e.preventDefault();
            
            filterOptions.forEach((filterOption) => {
            filterOption.classList.remove('active');
            });
            filterOption.classList.add('active');
        });
    });

    const removeHiddenPosts = (obj) => {
        
        obj = obj.filter((x, i, c) => {
            return (x.acf.hidden_from_view === false) ? x : null;
        });

        return obj;
    }; 

    // The method for handling a data request
    const dataRequest = ($url) => {

  

        /* Filter Scripts */
        var oReq = new XMLHttpRequest();
        oReq.addEventListener("load", transferComplete);
        oReq.addEventListener("error", transferFailed);
        oReq.addEventListener("abort", transferCanceled);

        oReq.open('GET', $url);
        oReq.send();

        function transferComplete(evt) {
            let completedRequest = JSON.parse(evt.currentTarget.response);
            renderHTML(orderProjects(removeHiddenPosts(completedRequest)));
            inheritLinks();
        }

        function transferFailed(evt) {
            // console.log("An error occurred while transferring the data.");
        }

        function transferCanceled(evt) {
            // console.log("The transfer has been canceled by the user.");
        }
    }

    const reWriteUrl = (nextState, nextTitle, nextURL) => {
        window.history.pushState(nextState, nextTitle, nextURL);
        window.history.replaceState(nextState, nextTitle, nextURL);
    }

    // Get the category from url /portfolio/?category=data-slug
    const dataParamName = new URL(window.location.href).searchParams.get("category");
    
    if (dataParamName) {
        dataParamName.toLocaleLowerCase();
        
        let getParam = document.querySelector('[data-slug="' + dataParamName  + '"]');
        // Remove all active classes
        filterBtns.forEach((filterBtn) => {
            filterBtn.classList.remove('active');
        });
        if (getParam) {
            // Add active class to the category in url
            getParam.classList.add('active');

            if (getParam.id === 'view-all') {
                // Run general request to fetch all posts
                dataRequest($restAPI);
            } else {
                // Run request for our current category in url
                dataRequest($restAPI + '&categories=' + getParam.id);
            }
        }
    }

    // Run request when clicking filter btns
    if (filterBtns) {
        // Filter Btns Controllers
        filterBtns.forEach((filterBtn) => {
            filterBtn.addEventListener('click', () => {

                if(filterBtn.id == 'view-all') {
                    dataRequest($restAPI);
                    const nextURL = window.location.protocol + '//' + window.location.hostname + '/portfolio/?category=' + filterBtn.id;
                    reWriteUrl({ additionalInformation: 'Updated the URL with JS' } ,filterBtn.id + ' page', nextURL);
                } else {
                    // Run request based on our filter category clicked
                    dataRequest($restAPI + '&categories=' + filterBtn.id);
                    // Re-write the url so we can share eg /portfolio/?category=data-slug
                    let dataSlug = filterBtn.dataset.slug;
                    const nextURL = window.location.protocol + '//' + window.location.hostname + '/portfolio/?category=' + dataSlug;
                    reWriteUrl({ additionalInformation: 'Updated the URL with JS' } ,dataSlug + ' page', nextURL);
                }
            });
        });
    }
    
    // This will set the right order in the design layout
    // postsData will return thumbnail_orientation true or false
    // Landscape is true 
    // Portrait is false
    // --> [ True ] --> [ False ] --> [ False ]
    const orderProjects = (postsData) => {
        // set loopActive to control our loop state
        let loopActive = 0;
        // set newProjects to hold our new ordered projects
        let newProjects = [];
        // algsTemp and algs arr to keep track of our layout
        //(Landscape = true, Portrait = false)
        let algsTemp = [true, false, true, true, false, false, true];
        let algs = [];

        let h = 0;
        if (postsData) {
            postsData.forEach((post, i) => {
                post.isComplete = false;
                newProjects.push(parseInt(0));
                algs[i] = algsTemp[h];
                h++;
                if(h > 7) { 
                    h = 0;
                }
            });

            [...algs].forEach((alg, i) => {
                loopActive = 1;      
                postsData.forEach((post, x) => {       
                    if(loopActive == 1) {             // If our argument has been fulfilled
                        if(post.thumbnail_orientation == alg) {    // If our Orientation is correct                   
                            if(post.isComplete == false) { // Its already been added or not
                                post.isComplete = true;
                                newProjects[i] = post;
                                loopActive = 0;
                            }
                        }
                    }
                });
            });
    
            // Check what posts are not complete (couldn't populate our newProjects array and return that)
            let post = postsData.filter((value, index, arr) => {
                if(value.isComplete == false) {
                    return value;
                }
            });
            // Add the post (not complete) as last elems in newProjects array
            newProjects = newProjects.concat(post);
    
            return newProjects;
        }
    }

    // Render HTML If Data
    const renderHTML = (newProjects) => {
        let renderHTML = '';
        // If we have posts loop through
        if(newProjects.length != 0) { 
            newProjects.forEach((postData, i) => {
                if(postData !== 0) {
                    let completeStatus = '';
                    if(postData.isComplete == false) {
                        completeStatus = 'is-not-complete';
                    }

                    // console.log(postData);
                    renderHTML += '<a data-pid="' + postData.id + '" data-catid="' + postData.categories[0] + '" href="'+ postData.link +'"  class="portfolio-post mb-100 md-mb-100 ' + postData.category_slug + ' ' + completeStatus + '">';
                        renderHTML += '<div class="portfolio-post-image mb-30 md-mb-30">';
                            renderHTML += '<img src="' + postData.thumbnail_img_url + '" alt="' + postData.title.rendered + '" />';
                        renderHTML += '</div>';
                        renderHTML += '<div class="portfolio-post-info">';
                            renderHTML += '<div class="portfolio-post-title mb-10 md-mb-5">';
                                renderHTML += '<h2 class="fs-25">' + postData.category_name + '</h2>';
                            renderHTML += '</div>';
                            renderHTML += '<div class="portfolio-post-link">';
                                renderHTML += '<span class="btn">' + postData.title.rendered;
                                renderHTML += '<span data-type="atom" data-temp="atom-icon-slash.twig" class="atom-icon-slash "><svg xmlns="http://www.w3.org/2000/svg" width="13.415" height="15.692" viewBox="0 0 13.415 15.692"><path class="slash-small" id="Black-slash-small" d="M4.97,15.692H0L8.445,0h4.97L4.97,15.692"></path></svg></span></span>';
                            renderHTML += '</div>';
                        renderHTML += '</div>';
                    renderHTML += '</a>';
                }
            });
            //postWrapper.innerHTML = renderHTML;

            let html = new DOMParser().parseFromString(renderHTML,"text/html");
            html = html.getRootNode();
            postWrapper.innerHTML = "";
            postWrapper.append(html.body);


            // console.log('content changed')


           
            npl.setEventListener(state);
              
            
            
         
            
        } else {
            renderHTML += '<div class="portfolio-post ">';
            renderHTML += '<h3 class="fs-25">No Projects Found</h3>';
            renderHTML += '</div>';
            postWrapper.innerHTML = renderHTML;
        }
    }
} 